import { useContext, useEffect, useState } from 'react';
import { Modal, Box, Grid, FormControlLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import checkmark from 'assets/modalKYX/checkmark2.png';
import hand from 'assets/modalKYX/hand.png';
import group842 from 'assets/modalKYX/group-842.png';
import PaystandCard from './PaystandCard/PaystandCard';
import { Cards } from 'lib/api';
import { SET_CARDS } from 'context/cards/types';
import { CardContext } from 'context/cards/cardContext';
import { AuthContext } from 'context/auth-context';
import CVVSwitch from './CVVSwitch';
import './ApprovedModal.css';

export const ModalApprovedAccount = ({ open, handleClose }) => {
    const { cards, card, providerToken, dispatch, currentCard, shouldUpdateCardList } = useContext(CardContext);
    const { businessInfo } = useContext(AuthContext);
    const { name, solidData, id } = cards[0] ? cards[0] : {};
    const [hidden, setHidden] = useState(true);
    const [showCardInfo, setShowCardInfo] = useState(false);
    const { publicSettings } = useContext(AuthContext);
    const { WELCOME_EXPERIENCE_POST_KYB } = publicSettings;

    const handleCheckoutClick = () => {
        setHidden(false);
    };

    useEffect(() => {
        const fetchCards = async () => {
            try {
                const queryParams = {
                    search: businessInfo.id
                };
                const response = await Cards.getCards(queryParams);
                dispatch({
                    type: SET_CARDS,
                    payload: response
                });
            } catch (error) {
                console.error(error);
            }
        };
        if (shouldUpdateCardList) {
            fetchCards();
        }
    }, [dispatch, shouldUpdateCardList]);

    useEffect(() => {
        if (!currentCard) return;
    }, [currentCard, dispatch]);

    return (
        <Modal open={open} onClose={handleClose} aria-describedby="child-modal-account-approved">
            <Box
                className="modal-component"
                sx={{
                    padding: { xs: '0px', md: '16px' },
                    border: { xs: '8px solid gray', md: 'unset' },
                    width: { xs: '404px', md: '800px' },
                    height: { xs: '726px', md: '600px' }
                }}>
                {hidden ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            item
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-checkmark"
                                sx={{
                                    width: { xs: 'auto', md: 'auto' },
                                    height: { xs: '256px !important', md: '568px !important' }
                                }}>
                                <img className="img-checkmark" src={checkmark} alt="Payment-Approved" />
                            </Box>

                            <button onClick={handleCheckoutClick} className="checkout-button">
                                Check out your DeFi Card
                            </button>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <Box className="box-hand">
                                <img className="img-hand" src={hand} alt="Payment-Approved" />
                                <label className="name-user">
                                    {WELCOME_EXPERIENCE_POST_KYB?.metadata?.step1?.welcomeMessage}, {businessInfo.legal_name}
                                </label>
                                <label className="complement-account">
                                    {WELCOME_EXPERIENCE_POST_KYB?.metadata?.step1?.title}
                                </label>
                                <label className="complement-info">
                                    {WELCOME_EXPERIENCE_POST_KYB?.metadata?.step1?.description}
                                </label>
                            </Box>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            item
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-checkmark"
                                sx={{
                                    width: { xs: 'auto', md: 'auto' },
                                    height: { xs: '256px !important', md: '568px !important' },
                                    display: { xs: 'flex' }
                                }}>
                                {solidData ? (
                                    <PaystandCard
                                        provider={providerToken}
                                        card={solidData}
                                        name={name}
                                        active={card?.cardId === providerToken?.id && currentCard}
                                        checked={showCardInfo}
                                        id={id}
                                    />
                                ) : (
                                    ''
                                )}
                            </Box>
                            {solidData ? (
                                <FormControlLabel
                                    sx={{
                                        display: 'flex',
                                        position: 'relative',
                                        marginLeft: { xs: '200px', md: '70px' },
                                        marginTop: { xs: '5px', md: '-100px' },
                                        bottom: { xs: '50px', md: '0px' }
                                    }}
                                    control={
                                        <CVVSwitch card={solidData} checked={showCardInfo} setChecked={setShowCardInfo} id={id} />
                                    }
                                    label={showCardInfo ? 'Hide Card Details' : 'Show Card Details'}
                                />
                            ) : (
                                ''
                            )}

                            <button onClick={handleClose} className="checkout-button-second">
                                Start using your card
                            </button>
                        </Grid>

                        <Grid item xs={12} md={7}>
                            <Box
                                className="box-hand"
                                width={{ xs: '329px', md: '374px' }}
                                height={{ xs: '321px !important', md: '321px !important' }}>
                                <img className="img-hand" src={group842} alt="Payment-Approved" />
                                <label className="text-how-works">{WELCOME_EXPERIENCE_POST_KYB?.metadata?.step2?.title}</label>
                                <Box className="box-checks">
                                    {WELCOME_EXPERIENCE_POST_KYB?.metadata?.step2?.bulletPoints?.map((bulletText, index) => (
                                        <Box key={index} className="box-check-1">
                                            <CheckCircleIcon color="primary" fontSize="small"></CheckCircleIcon>
                                            <p className="text-check-1">{bulletText}</p>
                                        </Box>
                                    ))}
                                </Box>

                                <label className="complement-info"></label>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Modal>
    );
};
